import { BeatLoader } from './BeatLoader';
import { BEAT_PATTERNS } from '../../../src/constants/danceLoaders';

// quick - quick - slow
export function KizombaLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.kizomba} />;
}

// step - step - shuffle - step
export function KizombaStepLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.kizombaStep} />;
}

// 1 - 2 - marca
export function KizombaMarcaLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.kizombaMarca} />;
}
